
export default function Authority() {
  const partners = [
    {
      name: 'Maxeon',
      subtitle: 'Japan Exclusive Agency',
      description: 'マキシオン正規代理店',
      emoji: '🌟'
    },
    {
      name: 'Tesla Powerwall',
      subtitle: 'Certified Installer',
      description: 'テスラ認定施工店',
      emoji: '⚡'
    },
    {
      name: 'Hanwha Q CELLS',
      subtitle: 'Official Partner',
      description: 'ハンファQセルズ正規販売店',
      emoji: '☀️'
    },
    {
      name: 'Canadian Solar',
      subtitle: 'Authorized Dealer',
      description: 'カナディアンソーラー正規販売店',
      emoji: '🍁'
    },
    {
      name: '長州産業',
      subtitle: 'Official Partner',
      description: '長州産業正規販売店',
      emoji: '🔋'
    }
  ];

  const achievements = [
    {
      icon: 'ri-home-smile-line',
      number: '10,000',
      unit: '棟突破',
      label: 'グループ累計施工実績',
      color: 'from-teal-400 to-emerald-400',
      bgColor: 'bg-teal-50',
      emoji: '🏠'
    },
    {
      icon: 'ri-team-line',
      number: '500',
      unit: '社以上',
      label: '提携工務店様',
      color: 'from-emerald-400 to-green-400',
      bgColor: 'bg-emerald-50',
      emoji: '🤝'
    },
    {
      icon: 'ri-star-smile-line',
      number: '98',
      unit: '%',
      label: '顧客満足度',
      color: 'from-cyan-400 to-teal-400',
      bgColor: 'bg-cyan-50',
      emoji: '⭐'
    }
  ];

  return (
    <section id="authority" className="py-12 md:py-24 bg-gradient-to-b from-teal-50/50 to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-white text-teal-600 px-4 py-1.5 md:px-5 md:py-2 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6 shadow-md">
            <i className="ri-award-line"></i>
            信頼の証
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4 px-2">
            正規代理店・認定施工店としての<span className="text-teal-500">信頼</span>
          </h2>
          <div className="w-16 md:w-20 h-1 md:h-1.5 bg-gradient-to-r from-teal-400 to-emerald-400 mx-auto mt-4 md:mt-6 rounded-full"></div>
          <p className="text-gray-600 text-sm md:text-base mt-4 md:mt-6 max-w-3xl mx-auto">
            世界トップクラスのメーカーから認定を受けた確かな技術力と実績
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mb-10 md:mb-16">
          {partners.map((partner, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl md:rounded-2xl p-3 md:p-5 shadow-md hover:shadow-lg transition-all duration-300 text-center hover:scale-105 cursor-pointer border border-teal-100 hover:border-teal-200"
            >
              <div className="w-10 h-10 md:w-14 md:h-14 bg-gradient-to-br from-teal-100 to-emerald-100 rounded-xl md:rounded-2xl flex items-center justify-center mx-auto mb-2 md:mb-3 text-xl md:text-2xl">
                {partner.emoji}
              </div>
              <h3 className="font-bold text-gray-800 text-xs md:text-sm mb-0.5 md:mb-1">
                {partner.name}
              </h3>
              <p className="text-[10px] md:text-xs text-teal-500 font-medium mb-0.5 md:mb-1">
                {partner.subtitle}
              </p>
              <p className="text-[10px] md:text-xs text-gray-500">
                {partner.description}
              </p>
            </div>
          ))}
        </div>

        {/* Achievements */}
        <div className="grid grid-cols-3 gap-3 md:gap-6 mb-10 md:mb-16">
          {achievements.map((achievement, index) => (
            <div 
              key={index}
              className={`${achievement.bgColor} rounded-2xl md:rounded-3xl p-4 md:p-8 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer border border-white`}
            >
              <div className="text-3xl md:text-5xl mb-2 md:mb-4">
                {achievement.emoji}
              </div>
              <div className="mb-1 md:mb-3">
                <span className="text-xl md:text-4xl font-bold text-gray-800">{achievement.number}</span>
                <span className="text-sm md:text-xl font-bold text-teal-500 ml-0.5 md:ml-1">{achievement.unit}</span>
              </div>
              <p className="text-gray-700 font-medium text-xs md:text-base">
                {achievement.label}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Message */}
        <div className="bg-gradient-to-r from-teal-400 to-emerald-400 rounded-2xl md:rounded-3xl p-6 md:p-10 text-center shadow-lg">
          <div className="max-w-4xl mx-auto">
            <span className="text-4xl md:text-5xl mb-3 md:mb-4 block">🏆</span>
            <h3 className="text-lg md:text-2xl font-bold text-white mb-3 md:mb-4">
              確かな実績と信頼のパートナーシップ
            </h3>
            <p className="text-white/90 text-sm md:text-base leading-relaxed">
              グループ累計10,000棟を超える施工実績と、世界トップクラスのメーカーとの強固なパートナーシップ。<br className="hidden md:block" />
              工務店様に安心してお任せいただける体制を整えております。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
